/**
 * @file Route path helpers for top-level board and app views.
 */

import {
    buildDrugPath,
    normalizeDrugSubView,
} from "./drugRoutes.js";
import {
    buildCalendarPath,
    normalizeCalendarSubView,
} from "./calendarRoutes.js";

/**
 * Normalizes sub-view state for top-level app routes.
 * @param {string} viewName - Route view key.
 * @param {string|null} subView - Candidate sub-view value.
 * @returns {string|null} Normalized sub-view or null.
 */
export function normalizeRouteSubView(viewName, subView = null) {
    if (viewName === "drugs") {return normalizeDrugSubView(subView);}
    if (viewName === "calendar") {return normalizeCalendarSubView(subView);}
    return null;
}

/**
 * Builds the browser path for a top-level app route.
 * @param {string} viewName - Route view key.
 * @param {string|null} subView - Optional route sub-view.
 * @returns {string} Browser path for the route.
 */
export function buildViewPath(viewName, subView = null) {
    if (viewName === "tasks") {return "/";}
    if (viewName === "drugs") {return buildDrugPath(subView);}
    if (viewName === "calendar") {return buildCalendarPath(subView);}
    return `/${viewName}`;
}

/**
 * Extracts a top-level app view key from a simple route pathname.
 * @param {string} pathname - Browser pathname.
 * @returns {string|null} View key candidate, or null for root/empty paths.
 */
export function getViewKeyFromPath(pathname) {
    if (!pathname || pathname === "/") {return null;}

    const segments = pathname.split("/").filter(Boolean);
    return segments.length === 1 ? segments[0] : null;
}
